import React, { useEffect } from "react";

import ViewScroller from "../Common/ViewScroller/ViewScroller";
import RightModal from "../Modals/RightModal/RightModal";
import CommandesCreditsViewContent from "./CommandesCreditsViewContent";
import { useDispatch } from "react-redux";

const CommandesCreditsTabContent = ({ activeTab }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch({ type: "RESET_AVOIRS" });
  }, [dispatch]);
  return (
    <ViewScroller>
      <CommandesCreditsViewContent activeTab={activeTab} />
      <RightModal width={80} className="pb-4" />
    </ViewScroller>
  );
};

export default CommandesCreditsTabContent;
